import ReactDOM from 'react-dom';
/**
 * Calls ReactDOM.createPortal at client side or render children in place at server side
 *
 * React is aware of the difference between direct SS render & CS portal and won't throw errors
 * during rehydration.
 *
 * NOTE: children will be rendered in place at SSR, therefore, to avoid flash of unstyled modal,
 * make sure the modal is styled with global CSS and it should have viewport-relative position.
 *
 * @param {any} children        React's renderable components to be sent to portals
 * @param {string} selector   optional selector string to change portal container target
 * @return Renderable content for React JSX
 */
function createUniversalPortal(children, selector = '') {
    var _a;
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        // client side
        let domContainer = null;
        try {
            domContainer = (_a = document.querySelector(selector)) !== null && _a !== void 0 ? _a : document.body;
        }
        catch (err) {
            // in case of invalid selector error
            domContainer = document.body;
        }
        return ReactDOM.createPortal(children, domContainer);
    }
    // render children in place of Portal at server side will avoid
    // initial UI mismatch error during rehydration
    return children;
}
export default createUniversalPortal;
